"use client";

import { useState } from "react";
import { signIn } from "next-auth/react";
import { useRouter } from "next/navigation";
import Link from "next/link";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const result = await signIn("credentials", {
        email,
        password,
        redirect: false,
      });

      if (result?.error) {
        setError("Email ou mot de passe incorrect");
        setLoading(false);
      } else {
        router.push("/dashboard");
      }
    } catch {
      setError("Email ou mot de passe incorrect");
      setLoading(false);
    }
  }

  return (
    <div>
      {/* Logo */}
      <div className="mb-10">
        <div className="flex items-center gap-1">
          <img src="/logo-cityz.png" alt="Cityz" className="h-8 dark:hidden" />
          <img src="/logo-cityz-white.png" alt="Cityz" className="h-8 hidden dark:block" />
          <span className="text-sm font-semibold text-text-quaternary self-end mb-0.5" style={{ fontFamily: "var(--font-sora, var(--font-display))" }}>Prez</span>
        </div>
        <p className="text-sm mt-2 text-text-quaternary">
          Connectez-vous a votre espace
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-text-secondary mb-1.5">
            Email
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            className="w-full px-3.5 py-2.5 soft-inset bg-background rounded-xl text-sm text-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-accent"
            placeholder="votre@email.com"
          />
        </div>

        <div>
          <label htmlFor="password" className="block text-sm font-medium text-text-secondary mb-1.5">
            Mot de passe
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            className="w-full px-3.5 py-2.5 soft-inset bg-background rounded-xl text-sm text-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-accent"
          />
        </div>

        {error && (
          <div className="flex items-center gap-2 text-sm rounded-xl px-3 py-2 bg-danger-light text-danger-text soft-inset">
            <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
            </svg>
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full soft-btn cityz-gradient text-white py-3 rounded-xl font-semibold text-sm tracking-wide transition-all hover:opacity-90 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
        >
          {loading ? "Connexion..." : "Se connecter"}
        </button>
      </form>

      <div className="mt-6 text-center">
        <Link href="/reset-password" className="text-xs text-text-quaternary hover:text-accent transition-colors">
          Mot de passe oublie ?
        </Link>
      </div>
    </div>
  );
}
